import { RcFile, UploadFile } from 'antd/es/upload/interface';
import { options } from '../config/config';
import { message, Upload } from 'antd';
import { IntlShape } from 'react-intl';

export const beforeUpload = (file: RcFile, intl: IntlShape) => {
  const maxSizeInMB = options.images.maxSizeInMB;
  const allowedFormats = options.images.allowedFormats;

  if (file.size / 1024 / 1024 > maxSizeInMB) {
    message.error(
      intl.formatMessage({
        id: 'validation.max_file_size',
      })
    );
    return Upload.LIST_IGNORE;
  }

  if (!allowedFormats.includes(file.type)) {
    message.error(
      intl.formatMessage({
        id: 'validation.allowed_formats',
      })
    );
    return Upload.LIST_IGNORE;
  }
  return true;
};

export const getMimeType = (fileName: any) => {
  const extension = fileName.split('.').pop().toLowerCase();

  const mimeTypes: any = {
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    bmp: 'image/bmp',
    svg: 'image/svg+xml',
  };
  return mimeTypes[extension] || 'application/octet-stream';
};

export const normalizeFileNames = (files: UploadFile[]): UploadFile[] => {
  const nameCounts: Record<string, number> = {};
  const usedNames = new Set<string>();

  return files.map((file) => {
    const extMatch = file.name.match(/\.[^/.]+$/);
    const ext = extMatch ? extMatch[0] : '';

    const actualName = file.name.replace(/^([^_]+_\d+_)/, '');
    const baseName = actualName.replace(ext, '');

    let newBase = baseName;
    let suffix = nameCounts[baseName] ?? 0;
    let newName = `${newBase}${ext}`;

    while (usedNames.has(newName)) {
      suffix += 1;
      newName = `${newBase}_${suffix}${ext}`;
    }

    nameCounts[baseName] = suffix;
    usedNames.add(newName);

    return {
      ...file,
      name: newName,
    };
  });
};
